import React from "react";
import { JsonDiffComponent, JsonValue } from "json-diff-react";
import DataNotAvailableMessage from "./DataNotAvailableMessage";

type Props = {
  jsonA: JsonValue;
  jsonB: JsonValue;
  excludeKeys?: string[];
};

const StyledJsonDiff: React.FC<Props> = ({
  jsonA,
  jsonB,
  excludeKeys = ["modified_at"],
}) => {
  if (!jsonA || !jsonB) {
    return <DataNotAvailableMessage message="No data available" />;
  }
  if (JSON.stringify(jsonA) === JSON.stringify(jsonB)) {
    return <DataNotAvailableMessage message="No data changed" />;
  }
  return (
    <div className="flex-1 rounded-md bg-gray-1 p-4">
      <JsonDiffComponent
        jsonA={jsonA}
        jsonB={jsonB}
        jsonDiffOptions={{
          maxElisions: 1,
          excludeKeys,
        }}
        styleCustomization={{
          additionLineStyle: { color: "#21a65e" },
          deletionLineStyle: { color: "#d9281c" },
          unchangedLineStyle: { color: "#8a8a8a" },
          frameStyle: {
            fontFamily: "monospace",
            whiteSpace: "pre",
            backgroundColor: "transparent",
          },
        }}
      />
    </div>
  );
};

export default StyledJsonDiff;
